<template>
    <section class="title-map-list-toggle component-header" id="title-map-list-toggle">
        <h1 v-if="title" class="headline-1">{{ title }}</h1>
        <div class="slot">
            <slot />
        </div>        
        <div class="view-buttons">
            <button type="button" class="map-folded view-button" @click.prevent="viewToggle(true)" aria-label="Map view" :aria-pressed="String(mapView)">
                <SvgsMapFolded class="svg" :class="{ active: mapView }" />
            </button>
            <button type="button" class="list view-button" @click.prevent="viewToggle(false)" aria-label="List view" :aria-pressed="String(!mapView)">
                <SvgsList class="svg" :class="{ active: !mapView }" />
            </button>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        title: {
            type: String,
            required: true,
            default: '',
        },
        mapView: {
            type: Boolean,
            required: true,
            default: true,
        },
    });

    const emit = defineEmits(['viewToggle']);

    function viewToggle(val) {
        emit('viewToggle', val);
    }
    defineExpose({
        viewToggle,
    });
</script>

<style lang="scss">
    .title-map-list-toggle {
        padding: 20px 8px;

        &.component-header {
            margin-bottom: 0;
            
            .slot {
                margin-left: auto;
            }
        }

        .view-buttons {
            display: flex;

            .view-button {
                margin-left: 15px;

                &.map-folded {
                    path,
                    line {
                        stroke: $gray-common;
                        transition: stroke 0.25s ease-in-out;
                    }

                    .active {
                        path,
                        line {
                            stroke: $black;
                            transition:
                                stroke 0.25s ease-in-out,
                                fill 0.25s ease-in-out;
                        }
                    }
                }

                &.list {
                    .svg {
                        circle,
                        path,
                        line {
                            stroke: $gray-common;
                            fill: $gray-common;
                            transition:
                                stroke 0.25s ease-in-out,
                                fill 0.25s ease-in-out;
                        }

                        &.active {
                            circle,
                            path,
                            line {
                                stroke: $black;
                                fill: $black;
                                transition: stroke 0.25s ease-in-out;
                            }
                        }
                    }
                }
            }
        }

        @media (min-width: $tablet) {
            position: relative;

            &.component-header {
                padding: 0 16px 20px;
            }

            .headline-1 {
                font-size: 3.5rem;
            }

            .view-buttons {

                .view-button {
                    width: 100%;
                    height: 100%;
                    
                    &:not(:last-child) {
                        margin-right: 20px;
                    }

                    svg {
                        width: 30px;
                        height: 30px;
                    }
                }
            }
        }

        @media (min-width: $desktop) {
            &.component-header {
                padding: 0px 8px 20px;
            }
        }
    }
</style>
